import Constants from '../../utils/Constants';
import { NewPdnShortcut, ShortcutProps } from './Utils';

export const NewPdnManifold = () => {
  const props: ShortcutProps = {
    projectNameKey: 'NewValveManifoldProject',
    systemNameKey: 'NewValveManifoldSystem',
    systemTypeUniqueId: Constants.systemTypes.pdn.multiPart,
    autoExecAction: Constants.autoExecActions.showAddPartDialog,
    addPartDialogSelection: Constants.autoExecActions.selectManifoldAddPartDialog,
  };

  return NewPdnShortcut(props);
};
